import { SwalAlert } from "./SwalAlert";

const Swalgeneral = (title, icon, text, info) => {

  let textoAlert = '';
  console.log(info);
  if (info !== undefined) {  
    info.then((result) => {

      console.log(result);
      const parsedObject = JSON.parse(result);
   
      const { msg } = parsedObject;
   console.log(msg);
      for (let key in msg) {
        if (key !== "0") {
          if (msg.hasOwnProperty(key)) {
            textoAlert = `${key}: ${msg[key]}\n`;
         
            SwalAlert(icon, title, textoAlert);
            break;
          }
        } else {
          textoAlert = msg;
        
          SwalAlert(icon, title, textoAlert);
          break;
        }
      }
    });
  }else{
    textoAlert = text;
    SwalAlert(icon, title, textoAlert);
 
  }   
}
export default Swalgeneral;

// Code Analysis

// Objective:
// The objective of the Swalgeneral function is to display a pop-up message using the SweetAlert2 library. The function takes in three parameters: title, icon, and text, which are used to customize the message displayed to the user.

// Inputs:
// - title: a string representing the title of the message
// - icon: a string representing the icon to be displayed in the message (e.g. "success", "error", "warning")
// - text: a string representing the main text of the message

// Flow:
// 1. The function takes in the three input parameters: title, icon, and text.
// 2. The function calls the Swal.fire() method from the SweetAlert2 library.
// 3. The method displays a pop-up message with the specified title, icon, and text.

// Outputs:
// - A pop-up message displayed to the user with the specified title, icon, and text.

// Additional aspects:
// - The Swalgeneral function is a default export from a module that imports the SweetAlert2 library.
// - The function is designed to be a general-purpose function for displaying pop-up messages, with customizable title, icon, and text.
//Juan Fernando ROdriguez UDPS